<template lang="html">
  <div class="page-section carousel">
    <h2 class="list-title" v-if="title" v-html="title"></h2>

    <div class="container">
      <Carousel3d
        :perspective="20"
        :controlsVisible="true"
        :border="0"
        :startIndex="currentSlideIndex"
        ref="miniCarousel"
      >
        <Slide
          v-for="(item, index) in items"
          :class="['carousel-slide', slideClasses(item)]"
          :index="index"
          :key="`carousel-item-${index}`"
        >
          <div class="carousel-content" :style="backgroundImg(item)">
            <div class="carousel-inner">
              <h2 v-if="parse(item).heading" class="heading" @click="highlightField('heading')">
                {{ parse(item).heading }}
              </h2>

              <h3 v-if="parse(item).sub_heading" class="heading" @click="highlightField('sub heading')">
                {{ parse(item).sub_heading }}
              </h3>

              <p v-if="parse(item).text" @click="highlightField('text')">{{ parse(item).text }}</p>

              <a
                v-if="parse(item).button_text"
                class="btn is-light"
                @click="highlightField('button link')"
                :title="`Will link to: ${parse(item).button_link}`"
              >
                {{ parse(item).button_text }}
              </a>
            </div>
          </div>
        </Slide>
      </Carousel3d>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

import Carousel3d from './Carousel/Carousel3d'
import Slide from './Carousel/Slide'

export default {
  name: 'MiniCarousel',

  mixins: [parseComponent],

  props: {
    title: String,
    demoMode: Boolean,

    currentListItem: {
      type: Object,
      description: 'Current item'
    },

    items: {
      type: Array,
      description: 'All items'
    }
  },

  components: {
    Carousel3d,
    Slide
  },

  computed: {
    image() {
      return (item) => {
        return this.demoMode ? this.parse(item).image_url : item.image_versions[0].url
      }
    },

    backgroundImg() {
      return (slide) => {
        return `background-image: url('${this.image(slide)}');background-color:${this.parse(slide).background_colour}`
      }
    },

    currentSlideIndex() {
      return this.items.indexOf(this.currentListItem)
    },

    slideClasses() {
      return (slide) => {
        let parsedSlide = this.parse(slide)
        let hasContent = (parsedSlide.heading || parsedSlide.sub_heading || parsedSlide.text) && this.image(slide)
        return [{'has-content': hasContent}]
      }
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'

.carousel
  .carousel-slide
    &:after
      content: ''
      background: rgba(0, 0, 0, 0.3)
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      opacity: 0
      transition: opacity .3s ease-in-out

    &.has-content
      &:after
        opacity: 1

  .carousel-content
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-size: cover
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    text-align: center
    background-position: 50% 50%

  .carousel-inner
    z-index: 2

    h1, h2, h3, p
      margin: 10px 0
      line-height: 1
      color: #fff

    .btn
      color: #333!important

.carousel-3d-controls
  a
    opacity: 0.5
    transition: opacity .2s ease-in-out

    &:hover
      opacity: 1

  span
    color: #333
</style>
